// src/components/layout/MainLayout.js

import React from 'react';
import { Box } from '@mui/material';
import { TheAppBar } from './TheAppBar';
import { Footer } from './Footer';
import { BlurOverlay } from './BlurOverlay'; // <-- IMPORT THE NEW COMPONENT
import MobileAppPopup from './MobileAppPopup';
import CanadaPRChatBot from './CanadaPRChatBot';
// You might still use your hook for other effects on the AppBar
import { useScrollEffects } from '../hooks/useScrollEffects'; 

export const MainLayout = ({ children, tabValue, showTabs = true }) => {
  // You can still use your hook for elevation, opacity, etc., on the AppBar
  useScrollEffects({
    // Disable the blur from the hook since the overlay now handles it
    enableBlur: false,
  });

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      
      <MobileAppPopup />
      
      {/* 1. The AppBar. It can still get styles from your hook. */}
      <TheAppBar 
        tabValue={tabValue} 
        showTabs={showTabs} 
        // Note: You would modify TheAppBar to accept a style object
        // Example: sx={getAppBarStyles()}
      />

      {/* 2. THE BLUR OVERLAY. This creates the effect you want. */}
      <BlurOverlay />

      {/* 3. The main content. It sits below the AppBar and the Overlay. */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 1,
          // We add a negative margin top to pull the content up "under" the blur overlay
          // The value should be the height of the BlurOverlay from its own file
          marginTop: '-32px',
          // Add padding top to push the content's start position back down,
          // so it doesn't get hidden behind the AppBar and overlay on page load.
          paddingTop: '6px',
        }}
      >
        {children}
        <Footer />
      </Box>

      <CanadaPRChatBot />
    </Box>
  );
};

export default MainLayout;